import React from 'react'
import { FormTextField, useZionFormContext, FormInputGroup } from '@fs/zion-form'
import { Cell, Grid, SubheaderBlock, useAtSize } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import FadeIn from './FadeIn'
import PlaceField from './PlaceField'

export default function EventFields({ name, type }: { name?: string; type?: string }): JSX.Element {
  const [t] = useTranslation()
  const atSize = useAtSize()
  const { getValues, setValue } = useZionFormContext()
  const isMobile = atSize({ default: true, md: false })
  const yearLabel = isMobile ? t('ancestors.year.range.condensed-label') : t(`ancestors.${type}.range.label`)

  // Following functions auto fill date inputs left blank in order to encourage more narrow search parameters.
  function handleFromBlur(): void {
    const [dateBegin, dateEnd] = getValues([`${name}_date_begin`, `${name}_date_end`])
    if (dateBegin && !dateEnd) {
      setValue(`${name}_date_end`, dateBegin)
    }
  }

  function handleToBlur(): void {
    const [dateBegin, dateEnd] = getValues([`${name}_date_begin`, `${name}_date_end`])
    if (dateEnd && !dateBegin) {
      setValue(`${name}_date_begin`, dateEnd)
    }
  }

  return (
    <FadeIn>
      <Grid noHorizontalGutters>
        <Cell columns={isMobile ? 12 : 2} />
        <Cell columns={isMobile ? 12 : 4}>
          {isMobile && <SubheaderBlock size="sm" heading={t(`ancestors.${type}.header`)} />}
          <PlaceField name={name} type={type} />
        </Cell>
        <FormInputGroup label={yearLabel} columns={isMobile ? 12 : 4}>
          <Grid>
            <FormTextField
              columns={isMobile ? 6 : 2}
              placeholder={t('ancestors.from.label')}
              name={`${name}_date_begin`}
              data-testid={`${name}-range-from`}
              onBlur={handleFromBlur}
            />
            <FormTextField
              columns={isMobile ? 6 : 2}
              placeholder={t('ancestors.to.label')}
              name={`${name}_date_end`}
              data-testid={`${name}-range-to`}
              onBlur={handleToBlur}
            />
          </Grid>
        </FormInputGroup>
      </Grid>
    </FadeIn>
  )
}
